import React, { lazy } from 'react';

const CostDistributionPolicyForm = lazy(() =>
  import('./CostDistributionPolicyForm').then(module => ({
    default: module.CostDistributionPolicyForm,
  })),
);

const costDistributionPolicyRoutes = [
  {
    props: { exact: true, path: '/unit-cost-accounting/cost-distribution-policy' },
    component: <CostDistributionPolicyForm />,
  },
];

export default costDistributionPolicyRoutes;
